import {
    CHANGE_DAY_COLUMN_PREFIX,
    EColumnsFields,
    FIRST_DAY_COLUMN_PREFIX,
    LAST_DAY_COLUMN_PREFIX,
} from "app/common/campaigns/KeywordsCampaginKeywordsTableConsts";
import { EKeywordsReportKeywordsTableMetrics } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsReportTypes";
import type { IKWsReportSortTableParams } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/TableUtils/RankTrackerTablesTypes";

const tableTabsMap = {
    [EKeywordsReportKeywordsTableMetrics.POSITION]: "top_pos",
    [EKeywordsReportKeywordsTableMetrics.UNIVERSAL_POSITION]: "top_overall_pos",
    [EKeywordsReportKeywordsTableMetrics.CLICKS]: "clicks",
};

const DEFAULT_COLUMN_TO_SORT = "volume";

// The "Updated" column's dataIndex is the formatted display string (EColumnsFields.LAST_UPDATED).
// The backend only recognizes the raw "lastUpdated" sort token, so it must be translated here.
const LAST_UPDATED_SORT_FIELD = "lastUpdated";

const getPrefixToSplit = (metricToSplit: string, columnToSort: string): string => {
    switch (true) {
        case columnToSort.includes(`${metricToSplit}${EKeywordsReportKeywordsTableMetrics.POSITION}`):
            return `${metricToSplit}${EKeywordsReportKeywordsTableMetrics.POSITION}`;
        case columnToSort.includes(`${metricToSplit}${EKeywordsReportKeywordsTableMetrics.UNIVERSAL_POSITION}`):
            return `${metricToSplit}${EKeywordsReportKeywordsTableMetrics.UNIVERSAL_POSITION}`;
        default:
            return `${metricToSplit}${EKeywordsReportKeywordsTableMetrics.CLICKS}`;
    }
};

const sortGorupedColumns = (columnToSort: string, metricToSplit: string) => {
    const { POSITION, CLICKS, UNIVERSAL_POSITION } = EKeywordsReportKeywordsTableMetrics;

    switch (true) {
        case columnToSort.includes(`${metricToSplit}${POSITION}`):
            return tableTabsMap[POSITION];
        case columnToSort.includes(`${metricToSplit}${CLICKS}`):
            return tableTabsMap[CLICKS];
        default:
            return tableTabsMap[UNIVERSAL_POSITION];
    }
};

export const getKeywordsReportSortColumn = (
    columnToSort = DEFAULT_COLUMN_TO_SORT,
    asc = true,
): IKWsReportSortTableParams => {
    const sort: IKWsReportSortTableParams = {
        sort: columnToSort,
        asc,
    };
    if (!columnToSort) {
        return sort;
    }
    if (columnToSort === (EColumnsFields.LAST_UPDATED as string)) {
        return { sort: LAST_UPDATED_SORT_FIELD, asc };
    }
    const isFirstDayColumn = columnToSort.includes(FIRST_DAY_COLUMN_PREFIX);
    const isLastDayColumn = columnToSort.includes(LAST_DAY_COLUMN_PREFIX);
    if (columnToSort.includes(CHANGE_DAY_COLUMN_PREFIX)) {
        const prefixToSplit = getPrefixToSplit(CHANGE_DAY_COLUMN_PREFIX, columnToSort);
        const [_, siteToSort] = columnToSort.split(prefixToSplit);
        return {
            sortSite: siteToSort,
            sortMetricType: CHANGE_DAY_COLUMN_PREFIX,
            sort: sortGorupedColumns(columnToSort, CHANGE_DAY_COLUMN_PREFIX),
            asc,
        };
    } else if (isFirstDayColumn || isLastDayColumn) {
        const metricToSplit = isFirstDayColumn ? FIRST_DAY_COLUMN_PREFIX : LAST_DAY_COLUMN_PREFIX;
        const prefixToSplit = getPrefixToSplit(metricToSplit, columnToSort);
        const [_, siteToSort] = columnToSort.split(prefixToSplit);

        return {
            sortSite: siteToSort,
            sortMetricType: isFirstDayColumn ? "First" : "Last",
            sort: sortGorupedColumns(columnToSort, metricToSplit),
            asc,
        };
    }
    return sort;
};
